import * as React from "react";
import { Button } from "./button";
import { Spinner } from "./spinner";
import { cn } from "../../lib/utils";

type ButtonProps = React.ComponentProps<typeof Button>;

/**
 * Button that reflects an async/pending state. When `busy` is true it disables
 * itself, swaps a leading `Spinner` in, and shows `busyLabel` (falling back to
 * children). Replaces the ~20 `{busy ? "Extracting…" : "Extract"}` ternaries.
 *
 * Convention for `busyLabel`: the verb-ing form of the action —
 * "Extract" → "Extracting…", "Save" → "Saving…", "Generate" → "Generating…".
 */
export function AsyncButton({
  busy = false,
  busyLabel,
  disabled,
  children,
  className,
  ...props
}: ButtonProps & { busy?: boolean; busyLabel?: React.ReactNode }) {
  return (
    <Button
      {...props}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={cn(className)}
    >
      {busy ? <Spinner size={13} aria-label="Working" /> : null}
      {busy && busyLabel != null ? busyLabel : children}
    </Button>
  );
}
